import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PageHeader.css';

export default function PageHeader({ title, subtitle, icon, actions, backTo }) {
  const navigate = useNavigate();

  return (
    <div className="page-header">
      <div className="page-header__left">
        {backTo && (
          <button className="page-header__back" onClick={() => navigate(backTo)} aria-label="Go back">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
            </svg>
          </button>
        )}
        {icon && (
          <div className="page-header__icon">{icon}</div>
        )}
        <div className="page-header__text">
          <h1 className="page-header__title">{title}</h1>
          {subtitle && <p className="page-header__subtitle">{subtitle}</p>}
        </div>
      </div>
      {actions && (
        <div className="page-header__actions">{actions}</div>
      )}
    </div>
  );
}
